import { useState, useLayoutEffect, useId } from 'react';
import { createPortal } from 'react-dom';
import { PortalProps } from './types/portalProps';
import './portal.scss'

const Portal = (props: PortalProps) => {
    const [wrapper, setWrapper] = useState<HTMLElement | null>(null);
    const portalId = useId();

    const createDomElement = (domId: string) => {
        const element = document.createElement('div');
        element.setAttribute("id", domId);
        element.classList.add("portalItem");
        document.body.appendChild(element);
        return element;
    }

    useLayoutEffect(() => {
        let element = document.getElementById(portalId);
        let isCreated = false;
        if (!element) {
            isCreated = true;
            element = createDomElement(portalId);
        }
        setWrapper(element);

        return () => {
            if (isCreated && element?.parentNode) {
                element.parentNode.removeChild(element);
            }
        }
    }, [portalId]);

    if (wrapper === null) return null;

    return createPortal(props.children, wrapper);
}

export default Portal;